import React, { useEffect, useState, useCallback, useRef } from "react";

import {
  Layout,
  Card,
  Table,
  Radio,
  Input,
  Typography,
  Modal,
  Button,
  Form,
  Select,
  Spin,
  message,
  Pagination,
} from "antd";

import {
  EditOutlined,
  UserOutlined,
  DownloadOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router-dom";

// NOTE: changed import path as requested

import axios from "../api/Constant";

import { jsPDF } from "jspdf";

import autoTable from "jspdf-autotable";

import * as XLSX from "xlsx";

import {
  getFamilyMembersByFamilyPPP,
  updateFamilyMemberIncomeBulk,
  getAllGramPanchayat,
  getVillageByGP,
} from "../api/User"; // added GP / village APIs

const { Content } = Layout;

const { Title } = Typography;

const { Option } = Select;

// ... (your schemeList remains unchanged) ...

const schemeList = [
  { key: 1, srNo: 1, name: "वृद्धावस्था सम्मान भत्ता" },

  { key: 2, srNo: 2, name: "विधवा और निराश्रित महिला पेंशन" },

  { key: 3, srNo: 3, name: "विकलांगता पेंशन" },

  { key: 4, srNo: 4, name: "दीन दयाल लाड़ो लक्ष्मी योजना" },

  // {

  //   key: 5,

  //   srNo: 5,

  //   name: "18 वर्ष तक के स्कूल जाने वाले विकलांग बच्चों को वित्तीय सहायता",

  // },

  // { key: 6, srNo: 6, name: "बौना भत्ता" },

  // { key: 7, srNo: 7, name: "किन्नर भत्ता" },

  // { key: 8, srNo: 8, name: "कश्मीरी प्रवासियों को वित्तीय सहायता" },

  // {

  //   key: 9,

  //   srNo: 9,

  //   name: "कक्षा 1 से 8 तक के अनुसूचित जाति के छात्रों को मासिक वजीफा",

  // },

  // {

  //   key: 10,

  //   srNo: 10,

  //   name: "कक्षा 1 से 5 वीं में बीसी-ए छात्रों के लिए मासिक वजीफा",

  // },

  // {

  //   key: 11,

  //   srNo: 11,

  //   name: "कक्षा 1 से 5 वीं में बीसी-ए छात्रों के लिए मासिक वजीफा",

  // },

  // {

  //   key: 12,

  //   srNo: 12,

  //   name: "अनुसूचित जाति के छात्रों को मासिक भत्ता (1 से 5 वीं)",

  // },

  // {

  //   key: 13,

  //   srNo: 13,

  //   name: "अनुसूचित जाति के छात्रों को मासिक भत्ता (6 वीं से 8 वीं)",

  // },

  // { key: 14, srNo: 14, name: "बीसी-ए छात्रों को मासिक वजीफा" },

  // { key: 15, srNo: 15, name: "बीसी-ए छात्रों को मासिक वजीफा" },

  // { key: 16, srNo: 16, name: "अनुसूचित जाति के छात्रों को वार्षिक वजीफा" },

  // { key: 17, srNo: 17, name: "अनुसूचित जाति के छात्रों को वार्षिक वजीफा" },

  // {

  //   key: 18,

  //   srNo: 18,

  //   name: "कक्षा 1 से 5 वीं तक के बीपीएल छात्रों के लिए मासिक वजीफा",

  // },

  // {

  //   key: 19,

  //   srNo: 19,

  //   name: "गरीबी रेखा से नीचे के छात्रों के लिए मासिक छात्रवृत्ति 1 से 8 वीं",

  // },

  // {

  //   key: 20,

  //   srNo: 20,

  //   name: "कक्षा 6 से 8 वीं तक के बीपीएल छात्रों के लिए मासिक वजीफा",

  // },

  // {

  //   key: 21,

  //   srNo: 21,

  //   name: "कक्षा 9वीं से 12वीं तक के बीपीएल छात्रों के लिए मासिक वजीफा",

  // },

  // { key: 22, srNo: 22, name: "निरोगी 2022" },

  // { key: 23, srNo: 23, name: "हैप्पी कार्ड" },

  // {

  //   key: 24,

  //   srNo: 24,

  //   name: "अनुसूचित जाति के लिए पोस्ट मैट्रिक छात्रवृत्ति योजना",

  // },

  // {

  //   key: 25,

  //   srNo: 25,

  //   name: "अनुसूचित जाति के लिए पोस्ट मैट्रिक छात्रवृत्ति योजना",

  // },

  // {

  //   key: 26,

  //   srNo: 26,

  //   name: "अनुसूचित जाति के लिए पोस्ट मैट्रिक छात्रवृत्ति योजना",

  // },

  // { key: 27, srNo: 27, name: "बीसी के लिए पोस्ट मैट्रिक छात्रवृत्ति योजना" },
];

const BeneficiaryIncomeScreen = () => {
  const navigate = useNavigate();

  const [dataSource, setDataSource] = useState([]);

  const [isSchemeModalOpen, setIsSchemeModalOpen] = useState(false);

  const [selectedRowKey, setSelectedRowKey] = useState(null);

  const [statusFilter, setStatusFilter] = useState(null);

  const [isNewRecordModalOpen, setIsNewRecordModalOpen] = useState(false);

  const [searchText, setSearchText] = useState("");

  const searchDebounceRef = useRef(null);

  const [newRecordForm] = Form.useForm();

  const topScrollRef = useRef(null);

  const topInnerRef = useRef(null);

  const tableWrapperRef = useRef(null);

  const tableBodyRef = useRef(null);

  const [pagination, setPagination] = useState({
    current: 1,

    pageSize: 10,

    total: 0,
  });

  const location = useLocation();

  const navState = location.state || {};

  const [villageCode, setVillageCode] = useState(
    () => navState.villageCode ?? null
  );

  useEffect(() => {
    if (navState.villageCode) setVillageCode(navState.villageCode);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const [loading, setLoading] = useState(false);

  const [exporting, setExporting] = useState(false);

  const [exportingYojna, setExportingYojna] = useState(false);

  const [selectedRowKeysForSubmit, setSelectedRowKeysForSubmit] = useState([]);

  const [schemeResponses, setSchemeResponses] = useState(() => {
    try {
      const stored = localStorage.getItem("schemeResponsesByBeneficiary");

      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  });

  const [lockedRows, setLockedRows] = useState(() => {
    try {
      const stored = localStorage.getItem("lockedBeneficiaries");

      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  });

  const [editUsedRows, setEditUsedRows] = useState(() => {
    try {
      const stored = localStorage.getItem("editUsedBeneficiaries");

      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  });

  // Members modal state (from backend)

  const [isMembersModalOpen, setIsMembersModalOpen] = useState(false);

  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState([]);

  // --- NEW: GP & Village filter states ---

  const [gpList, setGpList] = useState([]);

  const [villageList, setVillageList] = useState([]);

  const [selectedGP, setSelectedGP] = useState(null);

  const [selectedVillage, setSelectedVillage] = useState(null);

  const [splitOptions, setSplitOptions] = useState({});

  const [splitLoading, setSplitLoading] = useState({});

  // HOF Income Verification states

  const [hofVerificationData, setHofVerificationData] = useState({});

  const [selectedRowKeysForHofSubmit, setSelectedRowKeysForHofSubmit] =
    useState([]);

  const [hofSubmitting, setHofSubmitting] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(
        "schemeResponsesByBeneficiary",

        JSON.stringify(schemeResponses)
      );
    } catch (e) {}
  }, [schemeResponses]);

  useEffect(() => {
    try {
      localStorage.setItem("lockedBeneficiaries", JSON.stringify(lockedRows));
    } catch (e) {}
  }, [lockedRows]);

  useEffect(() => {
    try {
      localStorage.setItem(
        "editUsedBeneficiaries",

        JSON.stringify(editUsedRows)
      );
    } catch (e) {}
  }, [editUsedRows]);

  useEffect(() => {
    const loadGPs = async () => {
      const token = sessionStorage.getItem("token");

      const user_id = sessionStorage.getItem("user_id");

      try {
        const res = await getAllGramPanchayat(token, user_id);

        if (res && (res.status === true || res.status === "success")) {
          setGpList(res.data || []);
        } else {
          console.warn("getAllGramPanchayat returned:", res);
        }
      } catch (err) {
        console.error("Error loading GPs", err);
      }
    };

    loadGPs();
  }, []);

  // FIXED: Updated loadSplitOptions function
  const loadSplitOptions = async (villageId, rowKey, userId = null) => {
    if (!villageId || villageId === "null" || villageId === "undefined") {
      setSplitOptions((s) => ({ ...s, [rowKey]: [] }));
      return;
    }

    setSplitLoading((s) => ({ ...s, [rowKey]: true }));

    try {
      const token = sessionStorage.getItem("token");

      // Clear any existing options for this row
      setSplitOptions((s) => ({ ...s, [rowKey]: [] }));

      // Get current row's family ID to exclude it from options
      const currentRow = dataSource.find(
        (r) => String(r.key) === String(rowKey)
      );
      const currentFamilyId = currentRow?.familyId;

      // Simple direct API call
      const response = await axios.get(
        `/get_families_in_village/${villageId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            user_id: userId || sessionStorage.getItem("user_id"),
            include_all: true,
          },
        }
      );

      // Process the response data
      let families = [];

      if (response.data) {
        // Handle different response structures
        if (Array.isArray(response.data)) {
          families = response.data;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          families = response.data.data;
        } else if (
          response.data.families &&
          Array.isArray(response.data.families)
        ) {
          families = response.data.families;
        } else if (typeof response.data === "object") {
          // Try to extract array from object
          const possibleArrays = Object.values(response.data).find((val) =>
            Array.isArray(val)
          );
          if (possibleArrays) families = possibleArrays;
        }
      }

      console.log(
        `Loaded ${families.length} families for village ${villageId}`
      );

      // Create options for the dropdown
      const options = families.map((family, index) => {
        const familyId =
          family.family_ppp_id ||
          family.family_id ||
          family.id ||
          `fam-${index}`;
        const familyName =
          family.family_head_name ||
          family.beneficiary_name ||
          family.name ||
          `Family ${index + 1}`;

        return {
          key: familyId,
          value: familyId, // Use familyId as value for easier matching
          label: `${familyId} — ${familyName}`,
          raw: family,
          family_ppp_id: familyId,
          family_head_name: familyName,
          village_name: family.village_name || family.village || "",
        };
      });

      // Filter out current row's family to prevent self-selection
      const filteredOptions = options.filter(
        (opt) => opt.key !== currentFamilyId
      );

      setSplitOptions((s) => ({
        ...s,
        [rowKey]: filteredOptions,
      }));

      // Save to localStorage
      try {
        const currentSplitOptions = JSON.parse(
          localStorage.getItem("splitOptionsByVillage") || "{}"
        );
        localStorage.setItem(
          "splitOptionsByVillage",
          JSON.stringify({
            ...currentSplitOptions,
            [rowKey]: filteredOptions,
          })
        );
      } catch (e) {
        console.warn("Could not save split options to localStorage");
      }
    } catch (err) {
      console.error("Error loading split options:", err);
      setSplitOptions((s) => ({ ...s, [rowKey]: [] }));
      message.error("Split families could not be loaded");
    } finally {
      setSplitLoading((s) => ({ ...s, [rowKey]: false }));
    }
  };

  // Fix the status filter in the fetchData function

  const fetchData = useCallback(
    async (page = 1, pageSize = 10) => {
      setLoading(true);

      try {
        const role_id = sessionStorage.getItem("role_id");

        const gp_data = sessionStorage.getItem("gp_data");

        const limit = pageSize;

        const offset = (page - 1) * pageSize;

        const params = {
          limit,

          offset,
        };

        // 🔍 SEARCH PARAMS

        // 🔍 COMBINED SEARCH (NAME or FAMILY ID)

        if (searchText && searchText.trim()) {
          const val = searchText.trim();

          // Search by family PPP ID (exact match) or beneficiary name (partial match)
          // Backend will handle both parameters if provided
          params.family_ppp_id = val;
    }

        if (role_id) params.role_id = role_id;

        if (villageCode) params.gram_panchayat_code = villageCode;

        if (gp_data) params.gp_data = gp_data;

        if (selectedVillage) params.village_id = selectedVillage;

        // 🟡 FIXED STATUS FILTER

        if (statusFilter) {
          if (statusFilter === "Pending") {
            params.status = "pending";
          } else if (statusFilter === "Yes") {
            params.status = "approved";
          } else if (statusFilter === "No") {
            params.status = "rejected";
          } else {
            // Handle other cases if needed

            params.status = statusFilter.toLowerCase();
          }
        }

        const token = sessionStorage.getItem("token");

        const res = await axios.get("/get_family_income", {
          params,

          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data && res.data.status === "success") {
          const rows = res.data.data || [];

          const mapped = rows.map((r, idx) => ({
            key: r.id || idx,

            beneficiaryName: r.family_head_name || r.member_name || "",

            fatherHusbandName: r.father_name || r.father_husband_name || "",

            familyId: r.family_ppp_id || r.family_id || "",

            mobile: r.mobile || r.phone || "",

            incomeGroup: r.family_income || r.income_group || "",

            village:
              r.village_name_hindi ||
              r.village_name ||
              r.village ||
              r.village_hindi ||
              "",

            isAgreed: r.is_agreed === false ? "नहीं" : "हाँ",

            reason: r.reason || "",

            familyType: "Individual",

            // HOF Verification fields from LEFT JOIN

            hofiv_id: r.hofiv_id || null,

            gs_hof_income_veri: r.gs_hof_income_veri || null,

            gs_hof_income_veri_remark: r.gs_hof_income_veri_remark || "",

            gs_hof_income_veri_datetime: r.gs_hof_income_veri_datetime || null,

            hof_update_count: r.hof_update_count ?? null,

            __full: r,
          }));

          setDataSource(mapped);

          setPagination((p) => ({
            ...p,

            current: page,

            pageSize,

            total: res.data.total || 0,
          }));
        } else {
          setDataSource([]);

          setPagination((p) => ({ ...p, total: 0 }));

          message.error(res.data?.message || "Failed to load data");
        }
      } catch (err) {
        console.error("get_family_income error", err);

        message.error("Error fetching data. See console.");

        setDataSource([]);
      } finally {
        setLoading(false);
      }
    },

    [villageCode, selectedVillage, searchText, statusFilter]
  );

  // 🔍 AUTO SEARCH WHEN USER TYPES (DEBOUNCED) - FIXED VERSION

  useEffect(() => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      setPagination((p) => ({ ...p, current: 1 }));
      fetchData(1, pagination.pageSize);
    }, 500); // debounce only, no validation

    return () => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
    };
  }, [searchText, statusFilter]);

  // FIXED: Use a ref to prevent duplicate calls

  const initialLoadRef = useRef(false);

  useEffect(() => {
    // Only fetch data once on initial mount

    if (!initialLoadRef.current) {
      initialLoadRef.current = true;

      fetchData(pagination.current, pagination.pageSize);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------- EXPORT TO EXCEL HANDLER ----------

  const handleExportPDF = async () => {
    try {
      setExporting(true);

      const token = sessionStorage.getItem("token");

      const role_id = sessionStorage.getItem("role_id");

      const gp_data = sessionStorage.getItem("gp_data");

      const limit =
        pagination.total && pagination.total > 0
          ? pagination.total
          : pagination.pageSize;

      const offset = 0;

      const params = { limit, offset };

      if (role_id) params.role_id = role_id;

      if (villageCode) params.gram_panchayat_code = villageCode;

      if (selectedVillage) params.village_id = selectedVillage;

      if (gp_data) params.gp_data = gp_data;

      const response = await axios.get("/download_family_details", {
        params,

        headers: { Authorization: token ? `Bearer ${token}` : undefined },

        responseType: "blob",
      });

      const disposition = response.headers?.["content-disposition"];

      let filename = "";

      if (disposition) {
        const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );

        if (match && match[1]) filename = match[1].replace(/['"]/g, "");
      }

      if (!filename) {
        filename = `family_details_${new Date()

          .toISOString()

          .replace(/[:.]/g, "-")}.pdf`;
      }

      const blob = new Blob([response.data], { type: "application/pdf" });

      const link = document.createElement("a");

      link.href = window.URL.createObjectURL(blob);

      link.download = filename;

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(link.href);

      message.success("PDF download started.");
    } catch (err) {
      console.error("Export PDF error:", err);

      message.error(
        "Export failed due to invalid login credentials. Since the user is not authenticated as a valid Gram Sachiv, the PDF export functionality is disabled."
      );
    } finally {
      setExporting(false);
    }
  };

  // ---------- EXPORT TO EXCEL HANDLER ----------

const handleExportPDFwithYojna = async () => {
  try {
    setExportingYojna(true);

    const token = sessionStorage.getItem("token");
    const role_id = sessionStorage.getItem("role_id");
    const gp_code = villageCode; // ✅ Use villageCode which contains gram_panchayat_code

    console.log("Export parameters:", { role_id, gp_code, villageCode });

    // Validation based on backend requirements
    if (role_id !== "1" && !gp_code) {
      message.error("ग्राम पंचायत कोड आवश्यक है");
      setExportingYojna(false);
      return;
    }

    const response = await axios.get(
      "/download_family_details_with_yojna",
      {
        params: {
          role_id: String(role_id),
          gram_panchayat_code: gp_code,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );

    // Create blob from response
    const blob = new Blob([response.data], { type: "application/pdf" });
    
    // Try to get filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let filename = `yojna_report_${Date.now()}.pdf`;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }
    
    // Create download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
    message.success("PDF डाउनलोड शुरू हो गया");
  } catch (err) {
    console.error("PDF export error:", err);
    
    if (err.response) {
      if (err.response.status === 400) {
        message.error("ग्राम पंचायत कोड आवश्यक है");
      } else if (err.response.status === 401) {
        message.error("अधिकृत नहीं हैं। कृपया लॉगिन करें");
      } else if (err.response.status === 500) {
        message.error("सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें");
      } else {
        // Try to parse error message from response
        try {
          const errorText = await err.response.data.text();
          const errorJson = JSON.parse(errorText);
          message.error(errorJson.error || errorJson.message || "PDF डाउनलोड विफल");
        } catch {
          message.error("PDF डाउनलोड विफल");
        }
      }
    } else {
      message.error("PDF डाउनलोड विफल");
    }
  } finally {
    setExportingYojna(false);
  }
};



  const handleExportExcelParivar = async () => {
  try {
    setExporting(true);

    const token = sessionStorage.getItem("token");
    const role_id = sessionStorage.getItem("role_id");
    const gp_code = villageCode; // gram_panchayat_code

    // Validation (same as backend)
    if (role_id !== "1" && !gp_code) {
      message.error("ग्राम पंचायत कोड आवश्यक है");
      return;
    }

    const response = await axios.get(
      "/download_family_details_with_yojna_excel",
      {
        params: {
          role_id: String(role_id),
          gram_panchayat_code: gp_code,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );

    // Create Excel blob
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Filename from header (if provided)
    const contentDisposition = response.headers["content-disposition"];
    let filename = `yojna_report_${Date.now()}.xlsx`;

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) filename = match[1];
    }

    // Trigger download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    message.success("Excel डाउनलोड शुरू हो गया");
  } catch (err) {
    console.error("Excel export error:", err);

    if (err.response?.status === 400) {
      message.error("ग्राम पंचायत कोड आवश्यक है");
    } else if (err.response?.status === 401) {
      message.error("आप अधिकृत नहीं हैं, कृपया लॉगिन करें");
    } else {
      message.error("Excel डाउनलोड विफल");
    }
  } finally {
    setExporting(false);
  }
};


  // ---------- CLIENT-SIDE EXPORT HANDLERS ----------

  // Export current table data to PDF (UI level)

  const handleExportTablePDF = () => {
    if (!dataSource || dataSource.length === 0) {
      message.warning("No data available");

      return;
    }

    try {
      const doc = new jsPDF("l", "mm", "a4"); // landscape orientation

      // Title (English for PDF compatibility)

      doc.setFontSize(16);

      doc.text("Beneficiary Income Details", 14, 15);

      // Date

      doc.setFontSize(10);

      doc.text(`Date: ${new Date().toLocaleDateString()}`, 14, 22);

      doc.text(`Total Records: ${dataSource.length}`, 14, 28);

      // Prepare table data with English headers

      const tableHeaders = [
        "Sr. No.",

        "Head Name",

        "Father Name",

        "Family ID (PPP)",

        "Income Group",

        "Village",

        "Agreement",

        "Reason",
      ];

      const tableData = dataSource.map((row, idx) => [
        (pagination.current - 1) * pagination.pageSize + idx + 1,

        row.beneficiaryName || "-",

        row.fatherHusbandName || "-",

        row.familyId || "-",

        row.incomeGroup || "-",

        row.village || "-",

        row.gs_hof_income_veri === "Yes"
          ? "Yes"
          : row.gs_hof_income_veri === "No"
          ? "No"
          : "-",

        row.gs_hof_income_veri_remark || "-",
      ]);

      // Use autoTable function directly

      autoTable(doc, {
        head: [tableHeaders],

        body: tableData,

        startY: 34,

        styles: {
          fontSize: 8,

          cellPadding: 2,

          overflow: "linebreak",
        },

        headStyles: {
          fillColor: [30, 64, 255],

          textColor: 255,

          fontStyle: "bold",
        },

        alternateRowStyles: {
          fillColor: [245, 247, 251],
        },

        columnStyles: {
          0: { cellWidth: 15 }, // Sr. No.

          1: { cellWidth: 40 }, // Head Name

          2: { cellWidth: 40 }, // Father Name

          3: { cellWidth: 25 }, // Family ID

          4: { cellWidth: 50 }, // Income Group

          5: { cellWidth: 30 }, // Village

          6: { cellWidth: 20 }, // Agreement

          7: { cellWidth: 40 }, // Reason
        },

        margin: { top: 34, left: 10, right: 10 },
      });

      // Save PDF

      const filename = `Beneficiary_Details_${
        new Date().toISOString().split("T")[0]
      }.pdf`;

      doc.save(filename);

      message.success("PDF download successful");
    } catch (err) {
      console.error("PDF export error:", err);

      message.error("PDF download failed: " + err.message);
    }
  };

  // Export current table data to Excel (UI level)

  const handleExportTableExcel = () => {
    if (!dataSource || dataSource.length === 0) {
      message.warning("कोई डेटा उपलब्ध नहीं है");

      return;
    }

    try {
      // Prepare data for Excel

      const excelData = dataSource.map((row, idx) => ({
        "क्र. सं.": (pagination.current - 1) * pagination.pageSize + idx + 1,

        "मुखिया का नाम": row.beneficiaryName || "-",

        "पिता का नाम": row.fatherHusbandName || "-",

        "परिवार पहचान पत्र नंबर": row.familyId || "-",

        "आय वर्ग": row.incomeGroup || "-",

        ग्राम: row.village || "-",

        सहमति: row.gs_hof_income_veri || "-",

        कारण: row.gs_hof_income_veri_remark || "-",
      }));

      // Create workbook and worksheet

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "लाभार्थी विवरण");

      // Set column widths

      const colWidths = [
        { wch: 8 }, // क्र. सं.

        { wch: 20 }, // मुखिया का नाम

        { wch: 20 }, // पिता का नाम

        { wch: 18 }, // परिवार पहचान पत्र नंबर

        { wch: 25 }, // आय वर्ग

        { wch: 15 }, // ग्राम

        { wch: 10 }, // सहमति

        { wch: 25 }, // कारण
      ];

      worksheet["!cols"] = colWidths;

      // Generate and download file

      const filename = `लाभार्थी_विवरण_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;

      XLSX.writeFile(workbook, filename);

      message.success("Excel डाउनलोड सफल");
    } catch (err) {
      console.error("Excel export error:", err);

      message.error("Excel डाउनलोड में त्रुटि");
    }
  };

  // ---------- rest of handlers ----------

  const handleRadioChange = (rowKey, value) => {
    if (lockedRows[rowKey]) return;

    setDataSource((prev) =>
      prev.map((row) =>
        row.key === rowKey
          ? {
              ...row,

              isAgreed: value,

              reason: value === "हाँ" ? "" : row.reason,
            }
          : row
      )
    );
  };

  const handleInputChange = (rowKey, dataIndex, value) => {
    if (lockedRows[rowKey]) return;

    setDataSource((prev) =>
      prev.map((row) =>
        row.key === rowKey ? { ...row, [dataIndex]: value } : row
      )
    );
  };

  const handleSchemeRadioChange = (beneficiaryKey, schemeKey, field, value) => {
    if (!beneficiaryKey || lockedRows[beneficiaryKey]) return;

    setSchemeResponses((prev) => {
      const prevForBeneficiary = prev[beneficiaryKey] || {};

      const prevScheme = prevForBeneficiary[schemeKey] || {};

      return {
        ...prev,

        [beneficiaryKey]: {
          ...prevForBeneficiary,

          [schemeKey]: {
            ...prevScheme,

            [field]: value,
          },
        },
      };
    });
  };

  const openNewRecordModal = () => {
    newRecordForm.resetFields();

    newRecordForm.setFieldsValue({
      incomeGroup: "रु. 1.00 लाख से कम",

      isAgreed: "हाँ",

      familyType: "Individual",

      splitFamilyId: undefined,
    });

    setIsNewRecordModalOpen(true);
  };

  const handleNewRecordCancel = () => setIsNewRecordModalOpen(false);

  const handleNewRecordSubmit = () => {
    newRecordForm

      .validateFields()

      .then((values) => {
        setDataSource((prev) => {
          const nextKey = prev.length ? prev[prev.length - 1].key + 1 : 1;

          const nextSrNo = prev.length + 1;

          const newRecord = {
            key: nextKey,

            srNo: nextSrNo,

            beneficiaryName: values.beneficiaryName,

            fatherHusbandName: values.fatherHusbandName || "",

            familyId: values.familyId || "",

            mobile: values.mobile || "",

            incomeGroup: values.incomeGroup,

            village: values.village || "",

            isAgreed: values.isAgreed,

            reason: values.reason || "",

            familyType: values.familyType || "Individual",

            splitFromKey: values.splitFamilyId || undefined,
          };

          return [...prev, newRecord];
        });

        setIsNewRecordModalOpen(false);
      })

      .catch(() => {});
  };

  const handleEditClick = (rowKey) => {
    if (!lockedRows[rowKey]) return;

    if (editUsedRows[rowKey]) {
      Modal.info({
        title: "Edit limit reached",

        content: "आप इस रिकॉर्ड को केवल एक बार संपादित कर सकते हैं।",
      });

      return;
    }

    setLockedRows((prev) => ({ ...prev, [rowKey]: false }));

    setEditUsedRows((prev) => ({ ...prev, [rowKey]: true }));

    Modal.success({
      title: "Edit enabled",

      content: "अब आप इस रिकॉर्ड को एक बार संपादित कर सकते हैं।",
    });
  };

  const handleMainSubmit = () => {
    if (!selectedRowKeysForSubmit.length) {
      Modal.info({
        title: "No beneficiary selected",

        content: "Please select at least one beneficiary to submit.",

        okText: "OK",
      });

      return;
    }

    const count = selectedRowKeysForSubmit.length;

    setLockedRows((prev) => {
      const updated = { ...prev };

      selectedRowKeysForSubmit.forEach((key) => {
        updated[key] = true;
      });

      return updated;
    });

    setSelectedRowKeysForSubmit([]);

    Modal.success({
      title: "Data submitted successfully",

      content: (
        <div>
          <p>{`Submitted ${count} selected beneficiaries.`}</p>

          <p>
            These rows are now locked. If a mistake is found you may unlock a
            row once using the row's edit icon.
          </p>
        </div>
      ),

      okText: "OK",
    });
  };

  // ========== HOF INCOME VERIFICATION HANDLERS ==========

  // Handle HOF verification radio change

  const handleHofVerificationChange = (rowKey, value) => {
    setHofVerificationData((prev) => ({
      ...prev,

      [rowKey]: {
        ...prev[rowKey],

        gs_hof_income_veri: value,

        gs_hof_income_veri_remark:
          value === "Yes" ? "" : prev[rowKey]?.gs_hof_income_veri_remark || "",
      },
    }));
  };

  // Handle HOF verification remark change

  const handleHofRemarkChange = (rowKey, value) => {
    setHofVerificationData((prev) => ({
      ...prev,

      [rowKey]: {
        ...prev[rowKey],

        gs_hof_income_veri_remark: value,
      },
    }));
  };

  // Submit HOF Income Verification - FULL UPDATED VERSION
  const handleHofVerificationSubmit = async () => {
    if (!selectedRowKeysForHofSubmit.length) {
      Modal.info({
        title: "कोई लाभार्थी चयनित नहीं",
        content: "कृपया सबमिट करने के लिए कम से कम एक लाभार्थी का चयन करें।",
        okText: "ठीक है",
      });
      return;
    }

    // Validate selected records
    const recordsToSubmit = [];
    const validationErrors = [];

    for (const key of selectedRowKeysForHofSubmit) {
      const row = dataSource.find((r) => r.key === key);
      if (!row) continue;

      // Skip if already has verification
      if (row.hofiv_id) {
        message.warning(`${row.familyId} के लिए सत्यापन पहले से मौजूद है`);
        continue;
      }

      const hofData = hofVerificationData[key] || {};
      const status = hofData.gs_hof_income_veri || "Yes";
      const remark = hofData.gs_hof_income_veri_remark || "";

      // ✅ VALIDATION: If "No" selected, remark is mandatory
      if (status === "No" && !remark.trim()) {
        validationErrors.push(
          `${row.familyId}: "नहीं" चुनने पर कारण बताना आवश्यक है`
        );
        continue;
      }

      // Handle split family logic correctly
      let splitFamilyPPPId = null;
      if (row.familyType === "Split") {
        // Check if splitFromFamilyId exists and is different from familyId
        if (row.splitFromFamilyId && row.splitFromFamilyId !== row.familyId) {
          splitFamilyPPPId = row.splitFromFamilyId;
        } else if (
          row.splitFamilyPPPId &&
          row.splitFamilyPPPId !== row.familyId
        ) {
          splitFamilyPPPId = row.splitFamilyPPPId;
        } else {
          // If same ID, don't mark as split
          console.warn(
            `Family ${row.familyId} marked as Split but has same source ID`
          );
        }
      }

      // CRITICAL VALIDATION: Ensure split families have valid source
      if (row.familyType === "Split" && !splitFamilyPPPId) {
        validationErrors.push(
          `${row.familyId}: Split family must be split from a different family`
        );
        continue;
      }

      recordsToSubmit.push({
        fid_id: row.key,
        family_ppp_id: row.familyId, // This is the NEW split family ID
        village_id: row.__full?.village_id || "",
        village_name: row.village || "",
        hof_family_income: row.incomeGroup || row.__full?.family_income || "",
        gs_hof_income_veri: status,
        gs_hof_income_veri_remark: remark || null,
        family_type: row.familyType || "Individual",
        split_family_ppp_id: splitFamilyPPPId, // This should be the ORIGINAL family ID (DIFFERENT!)
        split_from_key: row.splitFromKey || null,
      });
    }

    // ✅ Show validation errors if any
    if (validationErrors.length > 0) {
      Modal.error({
        title: "सत्यापन त्रुटि",
        content: (
          <div>
            <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
              कृपया निम्नलिखित त्रुटियों को ठीक करें:
            </p>
            <ul style={{ paddingLeft: 20 }}>
              {validationErrors.map((err, idx) => (
                <li key={idx} style={{ color: "#ff4d4f", marginBottom: 4 }}>
                  {err}
                </li>
              ))}
            </ul>
          </div>
        ),
        okText: "ठीक है",
      });
      return;
    }

    if (!recordsToSubmit.length) {
      message.warning("सबमिट करने के लिए कोई वैध रिकॉर्ड नहीं है");
      return;
    }

    setHofSubmitting(true);

    try {
      const token = sessionStorage.getItem("token");
      const user_id = sessionStorage.getItem("user_id");

      const response = await axios.post(
        "/insert_hof_income_verification",
        {
          records: recordsToSubmit,
          user_id: user_id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data && response.data.status === "success") {
        message.success(
          `${response.data.inserted_count} रिकॉर्ड सफलतापूर्वक सबमिट किए गए`
        );
        setSelectedRowKeysForHofSubmit([]);
        setHofVerificationData({});
        fetchData(pagination.current, pagination.pageSize);
      } else {
        message.error(response.data?.message || "सबमिट करने में त्रुटि");
      }
    } catch (err) {
      console.error("HOF verification submit error:", err);
      message.error(err.response?.data?.message || "सबमिट करने में त्रुटि");
    } finally {
      setHofSubmitting(false);
    }
  };

  // Edit HOF Verification (one-time edit)
  const handleHofVerificationEdit = async (record) => {
    const hofData = hofVerificationData[record.key] || {};
    const status =
      hofData.gs_hof_income_veri || record.gs_hof_income_veri || "Yes";
    const remark =
      hofData.gs_hof_income_veri_remark ||
      record.gs_hof_income_veri_remark ||
      "";

    // Validate remark required for "No"
    if (status === "No" && !remark.trim()) {
      message.error("'नहीं' चुनने पर कारण बताना आवश्यक है");
      return;
    }

    // Handle split family information for the edit
    let splitFamilyPPPId = null;
    if (record.familyType === "Split") {
      // Check if splitFromFamilyId exists and is different from familyId
      if (
        record.splitFromFamilyId &&
        record.splitFromFamilyId !== record.familyId
      ) {
        splitFamilyPPPId = record.splitFromFamilyId;
      } else if (
        record.splitFamilyPPPId &&
        record.splitFamilyPPPId !== record.familyId
      ) {
        splitFamilyPPPId = record.splitFamilyPPPId;
      }
    }

    Modal.confirm({
      title: "संपादन की पुष्टि करें",
      content: "क्या आप इस सत्यापन को अपडेट करना चाहते हैं?",
      okText: "हाँ, अपडेट करें",
      cancelText: "रद्द करें",
      onOk: async () => {
        setHofSubmitting(true);
        try {
          const token = sessionStorage.getItem("token");
          const user_id = sessionStorage.getItem("user_id");

          const response = await axios.put(
            "/update_hof_income_verification",
            {
              hofiv_id: record.hofiv_id,
              gs_hof_income_veri: status,
              gs_hof_income_veri_remark: remark,
              user_id: user_id,
              family_type: record.familyType || "Individual",
              split_family_ppp_id: splitFamilyPPPId,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (response.data && response.data.status === "success") {
            message.success("सत्यापन सफलतापूर्वक अपडेट किया गया");
            setHofVerificationData((prev) => {
              const newData = { ...prev };
              delete newData[record.key];
              return newData;
            });
            fetchData(pagination.current, pagination.pageSize);
          } else {
            message.error(response.data?.message || "अपडेट करने में त्रुटि");
          }
        } catch (err) {
          console.error("HOF verification update error:", err);
          message.error(err.response?.data?.message || "अपडेट करने में त्रुटि");
        } finally {
          setHofSubmitting(false);
        }
      },
    });
  };

  const villageFamilies = dataSource.map((f) => ({
    key: f.key,

    familyId: f.familyId,

    beneficiaryName: f.beneficiaryName,

    fatherHusbandName: f.fatherHusbandName,

    mobile: f.mobile,

    incomeGroup: f.incomeGroup,

    isAgreed: f.isAgreed,

    reason: f.reason,

    village: f.village,

    __full: f.__full,
  }));

  // FIXED: handleRowFamilyTypeChange function
  const handleRowFamilyTypeChange = (rowKey, val) => {
    if (lockedRows[rowKey]) return;

    const currentRow = dataSource.find((r) => r.key === rowKey);

    // Prevent changing to Split if no other families exist in village
    if (val === "Split") {
      // Find village id for this row
      const rec = dataSource.find((d) => String(d.key) === String(rowKey));
      const villageId = rec?.__full?.village_id || selectedVillage || null;

      if (!villageId) {
        message.error(
          "Cannot mark as Split: Village information not available"
        );
        return;
      }

      // Check if there are other families in this village (excluding current)
      const otherFamiliesInVillage = dataSource.filter(
        (f) =>
          f.key !== rowKey &&
          (f.__full?.village_id === villageId || f.village_id === villageId)
      );

      if (otherFamiliesInVillage.length === 0) {
        message.warning(
          "No other families found in this village to split from"
        );
        // Still allow selection but warn user
      }
    }

    setDataSource((prev) =>
      prev.map((r) =>
        r.key === rowKey
          ? {
              ...r,
              familyType: val,
              splitFromKey: val === "Individual" ? null : r.splitFromKey,
              splitFromFamilyId:
                val === "Individual" ? null : r.splitFromFamilyId,
              splitFamilyPPPId:
                val === "Individual" ? null : r.splitFamilyPPPId,
            }
          : r
      )
    );

    if (val === "Split") {
      // Find village id for this row
      const rec = dataSource.find((d) => String(d.key) === String(rowKey));
      const villageId = rec?.__full?.village_id || selectedVillage || null;
      const userId = sessionStorage.getItem("user_id");

      if (villageId) {
        loadSplitOptions(villageId, rowKey, userId);
      } else {
        message.warning("Village information not found for this family");
        setSplitOptions((s) => ({ ...s, [rowKey]: [] }));
      }
    } else {
      // Clear split options when not split
      setSplitOptions((s) => ({ ...s, [rowKey]: [] }));
    }
  };

  // FIXED: handleRowSplitFamilyChange function
  const handleRowSplitFamilyChange = (rowKey, selectedFamilyId) => {
    if (lockedRows[rowKey]) return;

    // Find the selected family from split options
    const selectedOption = splitOptions[rowKey]?.find(
      (opt) => opt.value === selectedFamilyId || opt.key === selectedFamilyId
    );

    if (selectedOption) {
      const currentRow = dataSource.find((r) => r.key === rowKey);

      // CRITICAL: Ensure we're not splitting from the same family
      if (selectedOption.family_ppp_id === currentRow.familyId) {
        message.error("Cannot split a family from itself");
        return;
      }

      setDataSource((prev) =>
        prev.map((row) =>
          row.key === rowKey
            ? {
                ...row,
                beneficiaryName:
                  selectedOption.raw.family_head_name || row.beneficiaryName,
                fatherHusbandName:
                  selectedOption.raw.father_name || row.fatherHusbandName,
                // Keep the ORIGINAL family ID (this is the new split family)
                familyId: row.familyId,
                mobile: selectedOption.raw.mobile || row.mobile,
                incomeGroup:
                  selectedOption.raw.family_income || row.incomeGroup,
                village: selectedOption.raw.village_name || row.village,
                familyType: "Split",
                splitFromKey: selectedOption.key,
                splitFromFamilyId: selectedOption.family_ppp_id, // This should be DIFFERENT from familyId
                splitFamilyPPPId: selectedOption.family_ppp_id,
              }
            : row
        )
      );

      message.success(
        `Family marked as split from ${selectedOption.family_ppp_id}`
      );
    }
  };

  const schemeColumns = [
    { title: "क्र. सं.", dataIndex: "srNo", width: 70, align: "center" },

    {
      title: "योजना का नाम",

      dataIndex: "yojnaName",

      render: (_, record) => <span>{record.yojnaName || "-"}</span>,
    },

    {
      title: "पात्रता (हाँ / नहीं)",

      dataIndex: "eligible",

      width: 160,

      render: (_, record) => {
        const benResponses = schemeResponses[selectedRowKey] || {};

        const res = benResponses[record.key] || {};

        const isLocked = !!lockedRows[selectedRowKey];

        return (
          <Radio.Group
            size="small"
            value={res.eligible}
            disabled={isLocked}
            onChange={(e) =>
              handleSchemeRadioChange(
                selectedRowKey,

                record.key,

                "eligible",

                e.target.value
              )
            }
          >
            <Radio value="हाँ">हाँ</Radio>

            <Radio value="नहीं">नहीं</Radio>
          </Radio.Group>
        );
      },
    },

    {
      title: "लाभ प्राप्त हो सकता है (हाँ / नहीं)",

      dataIndex: "canGetBenefit",

      width: 210,

      render: (_, record) => {
        const benResponses = schemeResponses[selectedRowKey] || {};

        const res = benResponses[record.key] || {};

        const isLocked = !!lockedRows[selectedRowKey];

        return (
          <Radio.Group
            size="small"
            value={res.canGetBenefit}
            disabled={isLocked}
            onChange={(e) =>
              handleSchemeRadioChange(
                selectedRowKey,

                record.key,

                "canGetBenefit",

                e.target.value
              )
            }
          >
            <Radio value="हाँ">हाँ</Radio>

            <Radio value="नहीं">नहीं</Radio>
          </Radio.Group>
        );
      },
    },
  ];

  const memberCols = [
    { title: "सदस्य का नाम", dataIndex: "memberName", width: 150 },

    { title: "पिता का नाम", dataIndex: "fatherHusbandName", width: 150 },

    { title: "सदस्य आईडी", dataIndex: "memberId", width: 140 },

    { title: "संबंध", dataIndex: "relation", width: 120 },

    {
      title: "PPP में सदस्य की आय",

      dataIndex: "originalIncome",

      width: 150,

      render: (val) => (val ? val : "-"),
    },

    {
      title: "क्या आप आय से सहमत हैं?",

      dataIndex: "radioValue",

      width: 180,

      render: (_, record) => {
        // Check if edit limit reached (update_count >= 2)

        const isAlreadyVerified =
          record.gs_income_ver === "Yes" || record.gs_income_ver === "No";

        // Allow edit if: not limit reached AND (not verified OR in edit mode)

        const canEdit = !isAlreadyVerified || record.isEditMode;

        return (
          <Radio.Group
            value={record.radioValue ?? "agree"}
            disabled={!canEdit}
            onChange={(e) => {
              if (!canEdit) {
                message.warning(
                  "इस रिकॉर्ड को संपादित करने के लिए 'संपादित करें' बटन पर क्लिक करें।"
                );
                return;
              }

              const val = e.target.value;

              setSelectedFamilyMembers((prev) =>
                prev.map((m) =>
                  m.key === record.key
                    ? {
                        ...m,

                        radioValue: val,

                        currentIncome: val === "agree" ? "" : m.currentIncome,
                      }
                    : m
                )
              );
            }}
          >
            <Radio value="agree">हाँ</Radio>

            <Radio value="disagree">नहीं</Radio>
          </Radio.Group>
        );
      },
    },

    {
      title: "नई आय भरें",
      dataIndex: "currentIncome",
      width: 140,
      render: (_, record) => {
        const isAlreadyVerified =
          record.gs_income_ver === "Yes" || record.gs_income_ver === "No";
        const canEdit = !isAlreadyVerified || record.isEditMode;
        const disableIncomeInput = record.radioValue !== "disagree" || !canEdit;

        // ✅ FIXED: Define showError variable
        const showError =
          record.radioValue === "disagree" &&
          (!record.currentIncome || record.currentIncome.trim() === "");

        return (
          <Input
            value={record.currentIncome}
            disabled={disableIncomeInput}
            placeholder={disableIncomeInput ? "" : "नई आय भरें"}
            status={showError ? "error" : ""}
            style={showError ? { borderColor: "#ff4d4f" } : {}}
            onChange={(e) => {
              const val = e.target.value;
              // Only allow numbers
              if (!/^[0-9]*$/.test(val)) return;
              setSelectedFamilyMembers((prev) =>
                prev.map((m) =>
                  m.key === record.key ? { ...m, currentIncome: val } : m
                )
              );
            }}
          />
        );
      },
    },
    {
      title: "योजना का नाम",

      dataIndex: "yojnaName",

      width: 260,

      render: (_, record) => (
        <div>{record.yojnaName || "—"}</div> // read-only
      ),
    },

    {
      title: "क्या यह इस योजना का सही लाभार्थी है?",
      dataIndex: "isEligible",
      width: 200,
      render: (_, record) => {
        const isPending = record.gs_scheme_veri === "Pending";
        const canEdit = isPending || record.isEditMode;

        const value =
          record.isEligible !== undefined
            ? record.isEligible
            : record.gs_scheme_veri === "No"
            ? "no"
            : "yes";

        return (
          <Radio.Group
            value={value}
            disabled={!canEdit}
            onChange={(e) => {
              if (!canEdit) {
                // ✅ FIXED: Remove editLimitReached reference
                if (!isPending && !record.isEditMode) {
                  message.warning(
                    "इस रिकॉर्ड को संपादित करने के लिए 'संपादित करें' बटन पर क्लिक करें।"
                  );
                }
                return;
              }

              const v = e.target.value;

              setSelectedFamilyMembers((prev) =>
                prev.map((m) =>
                  m.key === record.key
                    ? {
                        ...m,
                        isEligible: v,
                        remarks: v === "yes" ? "" : m.remarks,
                      }
                    : m
                )
              );
            }}
          >
            <Radio value="yes">हाँ</Radio>
            <Radio value="no">नहीं</Radio>
          </Radio.Group>
        );
      },
    },

    {
      title: "अगर नहीं, तो कारण बताएं",

      dataIndex: "remarks",

      width: 180,

      render: (_, record) => {
        const isPending = record.gs_scheme_veri === "Pending";
        const canEdit = isPending || record.isEditMode;
        const allowEdit = canEdit && record.isEligible === "no";

        // ✅ Validation: If "नहीं" selected for scheme, reason is required

        const hasError =
          record.isEligible === "no" &&
          (!record.remarks || record.remarks.trim() === "");

        return (
          <Input
            value={record.remarks || ""}
            disabled={!allowEdit}
            placeholder={allowEdit ? "कारण लिखें *" : ""}
            status={hasError ? "error" : ""}
            style={hasError ? { borderColor: "#ff4d4f" } : {}}
            onChange={(e) => {
              const val = e.target.value;

              // ❌ Block Hindi / Non-ASCII characters

              const englishOnly = /^[\x00-\x7F]*$/;

              if (!englishOnly.test(val)) {
                message.warning("Only English text allowed");

                return;
              }

              setSelectedFamilyMembers((prev) =>
                prev.map((m) =>
                  m.key === record.key ? { ...m, remarks: val } : m
                )
              );
            }}
          />
        );
      },
    },
    // ✅ Status Column - Shows सबमिट/संपादित/पेंडिंग
    {
      title: "स्थिति",
      dataIndex: "status",
      width: 120,
      render: (_, record) => {
        const isVerified =
          record.gs_income_ver === "Yes" || record.gs_income_ver === "No";

        if (isVerified) {
          return (
            <span style={{ color: "#52c41a", fontWeight: "bold" }}>
              सत्यापित ✓
            </span>
          );
        } else {
          return <span style={{ color: "#faad14" }}>पेंडिंग</span>;
        }
      },
    },
    // ✅ Edit Button Column
    // Remove edit limit check in memberCols
    {
      title: "संपादन",
      dataIndex: "edit",
      width: 100,
      render: (_, record) => {
        const updateCount = record.update_count || 0;
        const isVerified =
          record.gs_income_ver === "Yes" || record.gs_income_ver === "No";

        // MODIFIED: Show edit button for all verified records
        if (isVerified) {
          return (
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => {
                // Simple confirmation without limit warning
                Modal.confirm({
                  title: "संपादन की पुष्टि करें",
                  content: "क्या आप इस रिकॉर्ड को संपादित करना चाहते हैं?",
                  okText: "हाँ, संपादित करें",
                  cancelText: "रद्द करें",
                  onOk: () => {
                    // Enable editing for this record
                    setSelectedFamilyMembers((prev) =>
                      prev.map((m) =>
                        m.key === record.key
                          ? {
                              ...m,
                              isEditMode: true,
                              gs_income_ver: "Pending",
                              gs_scheme_veri: "Pending",
                              radioValue: null,
                              isEligible: undefined,
                            }
                          : m
                      )
                    );
                    message.success("अब आप इस रिकॉर्ड को संपादित कर सकते हैं।");
                  },
                });
              }}
            >
              संपादित करें
            </Button>
          );
        } else {
          return <span style={{ color: "#999" }}>—</span>;
        }
      },
    },
  ];

  const handleOpenMembers = async (record) => {
    const token = sessionStorage.getItem("token");

    const family_ppp_id =
      record?.__full?.family_ppp_id ||
      record?.__full?.family_id ||
      record?.family_ppp_id ||
      record?.familyId ||
      record?.key;

    if (!family_ppp_id) {
      message.error("family_ppp_id not found for this record");

      return;
    }

    setLoading(true);

    try {
      const res = await axios.get("/get_family_member", {
        params: { family_ppp_id },

        headers: { Authorization: `Bearer ${token}` },
      });

      if (res && res.data && res.data.status === true) {
        const members = res.data.data || [];

        const hasSubmittedRecords = res.data.hasSubmittedRecords || false;

        const hasEditLimitReached = res.data.hasEditLimitReached || false;

        // Map backend members

        const allMembers = members.map((m, idx) => ({
          key: m.id || idx,

          id: m.id,

          memberName: m.member_name || "",

          fatherHusbandName:
            m.father_name || m.father_husband_name || m.father || "",

          memberId: m.member_ppp_id,

          member_ppp_id: m.member_ppp_id,

          relation: m.relation_name || "",

          originalIncome: String(m.member_income ?? m.family_income ?? "0"),

          currentIncome:
            m.new_family_income === null || m.new_family_income === undefined
              ? "0"
              : String(m.new_family_income),

          radioValue:
            m.gs_income_ver === "Yes"
              ? "agree"
              : m.gs_income_ver === "No"
              ? "disagree"
              : null,

          gs_income_ver: m.gs_income_ver,

          new_family_income: m.new_family_income,

          gs_scheme_veri: m.gs_scheme_veri || "Pending",

          gs_scheme_remark: m.gs_scheme_remark || "",

          isEligible:
            m.gs_scheme_veri === "Yes"
              ? "yes"
              : m.gs_scheme_veri === "No"
              ? "no"
              : undefined,

          remarks: m.gs_scheme_remark || "",

          update_count: m.update_count || 0,

          isEditMode: false,

          yojnaName: m.scheme_name || "",

          __full: m,
        }));

        // ✅ Show confirmation warning if records already submitted

        // In handleOpenMembers function, simplify the warning
        if (hasSubmittedRecords) {
          Modal.info({
            title: "सूचना",
            content:
              "इस परिवार के कुछ सदस्यों का डेटा पहले से सत्यापित हो चुका है।",
            okText: "समझ गया",
          });
        }

        const isEditMode = editUsedRows[record.key] === true;

        const finalMembers = allMembers.map((m) =>
          isEditMode && (m.update_count || 0) < 2
            ? {
                ...m,

                gs_income_ver: "Pending",

                gs_scheme_veri: "Pending",

                radioValue: null,

                isEligible: undefined,

                remarks: m.remarks,
              }
            : m
        );

        setSelectedFamilyMembers(finalMembers);

        setIsMembersModalOpen(true);
      }
    } catch (err) {
      console.error("Error fetching family members", err);

      message.error("Error fetching family members");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyFamilyIncome = async () => {
    const token = sessionStorage.getItem("token");
    const user_id = sessionStorage.getItem("user_id");

    // Find members that need updating:
    // 1. Pending members (not yet submitted)
    // 2. OR members in edit mode (isEditMode = true)
    // 3. AND update_count < 2 (one-time edit allowed)
    const toUpdate = selectedFamilyMembers.filter((m) => {
      // Skip if edit limit reached

      const isPending =
        !m.gs_income_ver ||
        m.gs_income_ver === "Pending" ||
        m.gs_income_ver === null;
      const isInEditMode = m.isEditMode === true;

      // Allow update if pending or in edit mode
      if (!isPending && !isInEditMode) {
        return false;
      }

      // If no radio button selected, skip
      const effectiveRadio = m.radioValue ?? "agree";

      // If user selected "agree", we need to update status to "Yes"
      if (effectiveRadio === "agree") {
        return true;
      }

      // If user selected "disagree", include for update
      if (effectiveRadio === "disagree") {
        return true;
      }

      return false;
    });

    if (!toUpdate.length) {
      message.warning(
        "कृपया कम से कम एक सदस्य के लिए सहमति स्थिति (हाँ/नहीं) चुनें।"
      );
      return;
    }

    // ✅ MODIFIED VALIDATION: Allows 0 income
    const validationErrors = [];
    for (const member of toUpdate) {
      const effectiveRadio = member.radioValue ?? "agree";
      const effectiveEligible = member.isEligible ?? "yes";
      const memberName = member.memberName || member.memberId || "Unknown";

      // Validation 1: If "नहीं" selected for income, NEW INCOME field must be filled (can be 0)
      if (effectiveRadio === "disagree") {
        // Only check if field is empty, not the value
        if (
          member.currentIncome === undefined ||
          member.currentIncome === null ||
          member.currentIncome === ""
        ) {
          validationErrors.push(
            `${memberName}: "नहीं" चुनने पर नई आय भरना आवश्यक है।`
          );
        }
      }

      // Validation 2: If "नहीं" selected for scheme eligibility, reason is required
      if (effectiveEligible === "no") {
        if (!member.remarks || member.remarks.trim() === "") {
          validationErrors.push(
            `${memberName}: योजना के लिए "नहीं" चुनने पर कारण बताना आवश्यक है।`
          );
        }
      }
    }

    // Show validation errors if any
    if (validationErrors.length > 0) {
      Modal.error({
        title: "सत्यापन त्रुटि",
        content: (
          <div>
            <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
              कृपया निम्नलिखित त्रुटियों को ठीक करें:
            </p>
            <ul style={{ paddingLeft: 20 }}>
              {validationErrors.map((err, idx) => (
                <li key={idx} style={{ color: "#ff4d4f", marginBottom: 4 }}>
                  {err}
                </li>
              ))}
            </ul>
          </div>
        ),
        okText: "ठीक है",
      });
      return;
    }

    // Check if any member is in edit mode - show stronger warning
    const editModeMembers = toUpdate.filter((m) => m.isEditMode === true);
    const warningContent = `आप ${toUpdate.length} सदस्यों की आय सत्यापित करना चाहते हैं। क्या आप जारी रखना चाहते हैं?`;

    Modal.confirm({
      title: "सत्यापन की पुष्टि करें",
      content: warningContent,
      okText: "हाँ, सबमिट करें",
      cancelText: "रद्द करें",
      onOk: async () => {
        setLoading(true);

        let successCount = 0;
        let failedCount = 0;

        try {
          for (const member of toUpdate) {
            try {
              // Determine gs approval status based on radioValue
              const effectiveRadio = member.radioValue ?? "agree";
              const effectiveEligible = member.isEligible ?? "yes";
              const isApproved = effectiveRadio === "agree" ? "Yes" : "No";

              const payload = {
                user_id,
                records: [
                  {
                    id: member.id, // REQUIRED
                    member_ppp_id: member.member_ppp_id,
                    updated_income: member.currentIncome || "0",
                    is_approved_by_gs: isApproved,
                    is_scheme_verify:
                      effectiveEligible === "yes" ? "Yes" : "No",
                    is_scheme_verify_reason:
                      effectiveEligible === "no" ? member.remarks || "" : "",
                  },
                ],
              };

              console.log(`Updating ${member.member_ppp_id}:`, payload);

              const response = await axios.put(
                `update_family_member_income/${
                  member.member_ppp_id || member.memberId || member.key
                }`,
                payload,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              );

              if (response.data && response.data.status) {
                successCount++;
                // Update local state to reflect new update_count
                setSelectedFamilyMembers((prev) =>
                  prev.map((m) =>
                    m.key === member.key
                      ? {
                          ...m,
                          update_count: (m.update_count || 0) + 1,
                          isEditMode: false,
                          gs_income_ver: isApproved,
                          gs_scheme_veri:
                            effectiveEligible === "yes" ? "Yes" : "No",
                        }
                      : m
                  )
                );
                console.log(`Success: ${member.member_ppp_id}`);
              } else {
                failedCount++;
                console.error(`Failed: ${member.member_ppp_id}`, response.data);
              }
            } catch (error) {
              failedCount++;
              console.error(`Error updating ${member.member_ppp_id}:`, error);
            }

            await new Promise((resolve) => setTimeout(resolve, 50));
          }

          // Update local state with new values
          const finalized = selectedFamilyMembers.map((m) => {
            const wasUpdated = toUpdate.some(
              (u) =>
                (u.member_ppp_id || u.memberId || u.key) ===
                (m.member_ppp_id || m.memberId || m.key)
            );

            if (wasUpdated) {
              const updatedMember = toUpdate.find(
                (u) =>
                  (u.member_ppp_id || u.memberId || u.key) ===
                  (m.member_ppp_id || m.memberId || m.key)
              );

              return {
                ...m,
                originalIncome: updatedMember.currentIncome,
                gs_income_ver:
                  updatedMember.radioValue === "agree" ? "Yes" : "No",
                new_family_income: updatedMember.currentIncome,
                update_count: (m.update_count || 0) + 1, // ✅ Increment update_count
              };
            }
            return m;
          });

          setSelectedFamilyMembers(finalized);

          // Refresh main table
          fetchData(pagination.current, pagination.pageSize);

          message.success(
            `${successCount} सदस्यों की आय सफलतापूर्वक सत्यापित की गई। ${failedCount} विफल।`
          );

          setTimeout(() => {
            setIsMembersModalOpen(false);
            setSelectedFamilyMembers([]);
          }, 1000);
        } catch (err) {
          console.error("Overall error:", err);
          message.error("Error updating members. Check console.");
        } finally {
          setLoading(false);
        }
      },
    });
  };
  // --- handle GP change and load villages ---

  const handleGPChange = async (gp_code) => {
    setSelectedGP(gp_code);

    setVillageList([]);

    const token = sessionStorage.getItem("token");

    try {
      const res = await getVillageByGP(token, gp_code);

      if (res && (res.status === true || res.status === "success")) {
        const villages = (res.data || []).map((v) => ({
          village_code: v.village_code ?? v.code ?? v.id,

          village_name:
            v.village_name_hindi || v.village_name || v.name || v.village_name,

          original: v,
        }));

        setVillageList(villages);
      } else {
        console.warn("getVillageByGP returned:", res);

        setVillageList([]);
      }
    } catch (err) {
      console.error("Error loading villages", err);

      setVillageList([]);
    }
  };

  const handleVillageChange = (village_code) => {
    setSelectedVillage(village_code);

    // FIXED: Reset to page 1 and fetch data

    setPagination((prev) => ({ ...prev, current: 1 }));

    fetchData(1, pagination.pageSize);
  };

  const columns = [
    {
      title: "क्र. सं.",

      dataIndex: "srNo",

      width: 70,

      align: "center",

      fixed: "left",

      render: (_, __, idx) =>
        (pagination.current - 1) * pagination.pageSize + idx + 1,
    },

    {
      title: "मुखिया का नाम",

      dataIndex: "beneficiaryName",

      width: 150,

      align: "center",

      fixed: "left",

      render: (_, record) => {
        return (
          <span
            style={{
              color: "#1677ff",

              cursor: "pointer",

              textDecoration: "underline",
            }}
            onClick={(e) => {
              e.stopPropagation();

              handleOpenMembers(record);
            }}
          >
            {record.beneficiaryName}
          </span>
        );
      },
    },

    {
      title: "पिता का नाम",

      dataIndex: "fatherHusbandName",

      width: 180,

      align: "center",
    },

    {
      title: "परिवार पहचान पत्र नंबर (8 अंक)",

      dataIndex: "familyId",

      width: 190,

      align: "center",
    },

    { title: "आय वर्ग", dataIndex: "incomeGroup", width: 190, align: "center" },

    {
      title: "ग्राम",

      dataIndex: "village",

      width: 180,

      align: "center",

      render: (val) => (val ? val : "-"),
    },

    {
      title: "परिवार के प्रकार",
      dataIndex: "familyType",
      width: 320,
      align: "center",
      render: (_, record) => {
        const isLocked = !!lockedRows[record.key];
        const currentType = record.familyType || "Individual";
        const isSplitValid =
          currentType === "Split" &&
          record.splitFromFamilyId &&
          record.splitFromFamilyId !== record.familyId;

        return (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <Select
              value={currentType}
              onChange={(val) => handleRowFamilyTypeChange(record.key, val)}
              disabled={isLocked}
              style={{ width: 180 }}
            >
              <Option value="Individual">Individual</Option>
              <Option value="Split">Split</Option>
            </Select>

            {currentType === "Split" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Select
                  showSearch
                  placeholder="Choose family to split from"
                  onChange={(val) =>
                    handleRowSplitFamilyChange(record.key, val)
                  }
                  value={record.splitFromFamilyId}
                  disabled={isLocked}
                  style={{ minWidth: 260 }}
                  loading={splitLoading[record.key]}
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  status={
                    !isSplitValid && record.splitFromFamilyId ? "error" : ""
                  }
                >
                  {splitOptions[record.key]?.map((family) => (
                    <Option
                      key={family.value}
                      value={family.value}
                      label={family.label}
                      disabled={family.family_ppp_id === record.familyId}
                    >
                      {family.label}{" "}
                      {family.family_ppp_id === record.familyId
                        ? "(Current Family)"
                        : ""}
                    </Option>
                  ))}
                </Select>

                {/* Display split family info with validation */}
                {record.splitFromFamilyId && (
                  <div
                    style={{
                      fontSize: 12,
                      fontStyle: "italic",
                      color: isSplitValid ? "#555" : "#ff4d4f",
                    }}
                  >
                    {isSplitValid
                      ? `Split from: ${record.splitFromFamilyId}`
                      : `ERROR: Cannot split from same family (${record.splitFromFamilyId})`}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      },
    },

    {
      title: "क्या ग्राम सभा इस आय वर्ग से सहमत है? (हाँ/ नहीं)",

      dataIndex: "gs_hof_income_veri",

      width: 260,

      align: "center",

      render: (_, record) => {
        // If already verified, show saved value (editable only if update_count = 0)

        const hasVerification = record.hofiv_id !== null;

        const canEdit = !hasVerification || record.hof_update_count === 0;

        // Get current value from local state or from record

        const localData = hofVerificationData[record.key] || {};

        const currentValue =
          localData.gs_hof_income_veri || record.gs_hof_income_veri || "Yes";

        return (
          <Radio.Group
            value={currentValue}
            disabled={!canEdit}
            onChange={(e) =>
              handleHofVerificationChange(record.key, e.target.value)
            }
          >
            <Radio value="Yes">हाँ</Radio>

            <Radio value="No">नहीं</Radio>
          </Radio.Group>
        );
      },
    },
    {
      title: "यदि नहीं, तो कारण बताएं",
      dataIndex: "gs_hof_income_veri_remark",
      width: 220,
      align: "center",
      render: (_, record) => {
        const hasVerification = record.hofiv_id !== null;
        const canEdit = !hasVerification || record.hof_update_count === 0;
        const localData = hofVerificationData[record.key] || {};
        const currentStatus =
          localData.gs_hof_income_veri || record.gs_hof_income_veri || "Yes";
        const currentRemark =
          localData.gs_hof_income_veri_remark ??
          record.gs_hof_income_veri_remark ??
          "";

        const disableRemark = !canEdit || currentStatus === "Yes";

        // ✅ ADDED: Show error if "No" selected but remark is empty
        const showError = currentStatus === "No" && !currentRemark.trim();

        return (
          <Input
            placeholder={disableRemark ? "" : "कारण लिखें *"}
            value={currentRemark}
            maxLength={30}
            disabled={disableRemark}
            status={showError ? "error" : ""} // ✅ Red border for error
            style={showError ? { borderColor: "#ff4d4f" } : {}}
            onChange={(e) => handleHofRemarkChange(record.key, e.target.value)}
          />
        );
      },
    },

    {
      title: "HOF Action",
      key: "hofAction",
      width: 120,
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const hasVerification = record.hofiv_id !== null;

        if (!hasVerification) {
          return <span style={{ color: "#999" }}>-</span>;
        }

        // ✅ FIXED: Remove edit limit - always allow editing
        return (
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleHofVerificationEdit(record)}
            loading={hofSubmitting}
          >
            संपादित करें
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (!tableWrapperRef.current) return;

    const body = tableWrapperRef.current.querySelector(".ant-table-body");

    if (!body) return;

    tableBodyRef.current = body;

    if (topInnerRef.current) {
      topInnerRef.current.style.width = `${body.scrollWidth}px`;
    }

    const onBodyScroll = () => {
      if (topScrollRef.current) {
        topScrollRef.current.scrollLeft = body.scrollLeft;
      }
    };

    body.addEventListener("scroll", onBodyScroll);

    return () => body.removeEventListener("scroll", onBodyScroll);
  }, [dataSource, columns]);

  const rowSelection = {
    selectedRowKeys: selectedRowKeysForHofSubmit,

    onChange: (newSelected) => setSelectedRowKeysForHofSubmit(newSelected),

    getCheckboxProps: (record) => ({
      disabled: record.hofiv_id !== null, // Disable if already has verification
    }),
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    fetchData(current, pageSize);
  };

  const handleSchemeModalCancel = () => {
    setIsSchemeModalOpen(false);

    setSelectedRowKey(null);
  };

  const handleSchemeModalSubmit = () => {
    setIsSchemeModalOpen(false);

    setSelectedRowKey(null);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#f5f7fb" }}>
        <Content style={{ padding: "24px 32px" }}>
          <div style={{ marginBottom: 12 }}>
            <Button onClick={() => navigate("/gram-sabha-mom")}>
              ← ग्राम सभा MOM पर वापस जाएँ"
            </Button>
          </div>

          <Title
            level={4}
            style={{
              margin: 0,

              textAlign: "center",

              fontWeight: 900,
            }}
          >
            आय वर्ग अनुसार लाभार्थी विवरण
          </Title>

          {/* ===== SEARCH BAR ===== */}

          {/* ===== FILTER ROW: Gram Panchayat + Village ===== */}

          <div
            style={{
              marginBottom: 20,

              display: "flex",

              gap: 20,

              alignItems: "center",

              flexWrap: "wrap", // Added for responsiveness
            }}
          >
            <div
              style={{
                display: "flex",

                alignItems: "flex-end",

                justifyContent: "space-between",

                gap: 12,

                marginBottom: 12,

                flexWrap: "wrap", // Added for responsiveness
              }}
            >
              {/* LEFT SIDE */}

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {/* 🔍 SEARCH */}

                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>खोजें</div>

                  <Input
                    placeholder="परिवार पहचान पत्र नंबर"
                    value={searchText}
                    allowClear
                    onChange={(e) => {
                      let val = e.target.value;

                      // ✅ Allow alphanumeric only (paste-safe)
                      val = val.replace(/[^a-zA-Z0-9]/g, "");

                      setSearchText(val);
                    }}
                  />
                </div>

                {/* STATUS FILTER - MOVED TO LEFT SIDE */}

                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>स्थिति</div>

                  <Select
                    placeholder="सभी"
                    style={{ width: 180 }}
                    value={statusFilter}
                    onChange={setStatusFilter}
                    allowClear
                  >
                    <Option value="Pending">Pending</Option>

                    <Option value="Yes">Yes (Approved)</Option>

                    <Option value="No">No (Objection)</Option>
                  </Select>
                </div>
              </div>
            </div>

            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={() => {
                  setSelectedGP(null);

                  setSelectedVillage(null);

                  setVillageList([]);

                  setSearchText(""); // Clear search text

                  setStatusFilter(null); // Clear status filter

                  fetchData(1, pagination.pageSize);
                }}
              >
                फ़िल्टर रीसेट करें
              </Button>

              {/* Export buttons remain the same */}

              <Button
                icon={<DownloadOutlined />}
                onClick={handleExportPDFwithYojna}
                loading={exportingYojna}
              >
                परिवार अनुसार PDF डाउनलोड करें
              </Button>

              <Button
                icon={<DownloadOutlined />}
                onClick={handleExportExcelParivar}
                loading={exporting}
              >
                परिवार के अनुसार Excel डाउनलोड करें
              </Button>
            </div>
          </div>

          {/* ===== KPI COUNT CARD ===== */}

          {((pagination && pagination.current) || 1) === 1 && (
            <Card
              style={{
                borderRadius: 12,

                boxShadow: "0 6px 18px rgba(0, 60, 140, 0.15)",

                marginBottom: 20,

                padding: "14px 20px",

                background:
                  "linear-gradient(90deg, #1e40ff 0%, #3d63ff 45%, #4b7bff 100%)",

                border: "none",

                color: "#fff",

                width: "100%",

                height: 96,

                display: "flex",

                alignItems: "center",
              }}
              bodyStyle={{ padding: 0, width: "100%" }}
            >
              <div
                style={{
                  display: "flex",

                  alignItems: "center",

                  width: "100%",

                  justifyContent: "space-between",
                }}
              >
                {/* Left section: icon + texts */}

                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 56,

                      height: 56,

                      borderRadius: "50%",

                      background: "rgba(255,255,255,0.15)",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",
                    }}
                  >
                    <UserOutlined style={{ fontSize: 26, color: "#fff" }} />
                  </div>

                  <div
                    style={{
                      display: "flex",

                      flexDirection: "column",

                      lineHeight: 1,
                    }}
                  >
                    <div
                      style={{ fontSize: 12, fontWeight: 700, opacity: 0.95 }}
                    >
                      कुल परिवार
                    </div>

                    <div
                      style={{ fontSize: 30, fontWeight: 800, marginTop: 4 }}
                    >
                      {typeof pagination?.total === "number" &&
                      pagination.total > 0
                        ? pagination.total
                        : dataSource.length}
                    </div>
                  </div>
                </div>

                {/* Right section */}
              </div>
            </Card>
          )}

          <Card
            style={{
              borderRadius: 12,

              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            <Spin spinning={loading}>
              <div
                style={{
                  display: "flex",

                  justifyContent: "flex-end",

                  marginBottom: 8,
                }}
              >
                <Pagination
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  showSizeChanger
                  onChange={(page, pageSize) => fetchData(page, pageSize)}
                />
              </div>

              <div
                ref={topScrollRef}
                onScroll={(e) => {
                  if (tableWrapperRef.current) {
                    tableWrapperRef.current.scrollLeft = e.target.scrollLeft;
                  }
                }}
                style={{
                  overflowX: "auto",

                  overflowY: "hidden",

                  height: 14,

                  marginBottom: 6,
                }}
              >
                <div style={{ width: 2200, height: 1 }} />
              </div>

              <div
                ref={tableWrapperRef}
                onScroll={(e) => {
                  if (topScrollRef.current) {
                    topScrollRef.current.scrollLeft = e.target.scrollLeft;
                  }
                }}
                style={{ overflowX: "auto" }}
              >
                <Table
                  bordered
                  dataSource={dataSource}
                  columns={columns}
                  rowSelection={rowSelection}
                  pagination={false}
                  size="middle"
                  style={{ minWidth: 2200 }}
                />
              </div>
            </Spin>

            <div
              style={{
                marginTop: 16,

                display: "flex",

                justifyContent: "flex-end",

                gap: 8,
              }}
            >
              <Button
                type="primary"
                onClick={handleHofVerificationSubmit}
                loading={hofSubmitting}
                disabled={selectedRowKeysForHofSubmit.length === 0}
              >
                HOF आय सत्यापन सबमिट करें ({selectedRowKeysForHofSubmit.length})
              </Button>
            </div>
          </Card>
        </Content>
      </Layout>

      <Modal
        open={isSchemeModalOpen}
        onCancel={handleSchemeModalCancel}
        footer={[
          <Button key="cancel" onClick={handleSchemeModalCancel}>
            बंद करें
          </Button>,

          <Button key="submit" type="primary" onClick={handleSchemeModalSubmit}>
            सबमिट करें
          </Button>,
        ]}
        title="योजनाों की सूची"
        width={900}
        style={{
          top: 20,

          right: 0,

          left: "auto",

          position: "fixed",
        }}
        mask={false}
      >
        <Table
          dataSource={schemeList}
          columns={schemeColumns}
          size="small"
          pagination={false}
          bordered
        />
      </Modal>

      <Modal
        open={isMembersModalOpen}
        onCancel={() => {
          setIsMembersModalOpen(false);
          setSelectedFamilyMembers([]);
        }}
        footer={[
          <Button
            key="close"
            onClick={() => {
              setIsMembersModalOpen(false);
              setSelectedFamilyMembers([]);
            }}
          >
            बंद करें
          </Button>,

          <Button
            key="verify"
            type="primary"
            onClick={handleVerifyFamilyIncome}
            loading={loading}
          >
            परिवार आय सत्यापित करें
          </Button>,
        ]}
        title="परिवार सदस्य और आय सत्यापन"
        width={1200}
      >
        {selectedFamilyMembers && selectedFamilyMembers.length ? (
          <div style={{ overflowX: "auto" }}>
            <Table
              dataSource={selectedFamilyMembers}
              columns={memberCols}
              pagination={false}
              size="small"
              rowKey="key"
              bordered
              scroll={{ x: 1600 }}
            />
          </div>
        ) : (
          <div style={{ padding: 16 }}>
            <p>No members to show.</p>
          </div>
        )}
      </Modal>

      <Modal
        open={isNewRecordModalOpen}
        onCancel={handleNewRecordCancel}
        title="नया लाभार्थी रिकॉर्ड जोड़ें"
        footer={[
          <Button key="cancel" onClick={handleNewRecordCancel}>
            रद्द करें
          </Button>,

          <Button key="submit" type="primary" onClick={handleNewRecordSubmit}>
            सबमिट करें
          </Button>,
        ]}
        width={600}
      >
        <Form
          form={newRecordForm}
          layout="vertical"
          initialValues={{
            incomeGroup: "रु. 1.00 लाख से कम",

            isAgreed: "हाँ",

            familyType: "Individual",

            splitFamilyId: undefined,
          }}
        >
          <Form.Item
            label="परिवार के प्रकार"
            name="familyType"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select
              onChange={(val) => {
                if (val === "Individual")
                  newRecordForm.setFieldsValue({ splitFamilyId: undefined });
              }}
            >
              <Option value="Individual">Individual</Option>

              <Option value="Split">Split</Option>
            </Select>
          </Form.Item>

          {newRecordForm.getFieldValue("familyType") === "Split" && (
            <Form.Item
              label="Select family from village"
              name="splitFamilyId"
              rules={[{ required: true, message: "Please select a family" }]}
            >
              <Select
                showSearch
                placeholder="Choose family"
                optionFilterProp="children"
                onChange={(val) => {
                  const family = villageFamilies.find(
                    (f) => String(f.key) === String(val)
                  );

                  if (family) {
                    newRecordForm.setFieldsValue({
                      beneficiaryName: family.beneficiaryName || undefined,

                      fatherHusbandName: family.fatherHusbandName || undefined,

                      familyId: family.familyId || undefined,

                      mobile: family.mobile || undefined,

                      incomeGroup: family.incomeGroup || "रु. 1.00 लाख से कम",

                      village: family.village || undefined,

                      isAgreed: family.isAgreed || "हाँ",

                      reason: family.reason || "",
                    });
                  }
                }}
              >
                {villageFamilies.map((f) => (
                  <Option key={f.key} value={f.key}>
                    {f.familyId} — {f.beneficiaryName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            label="लाभार्थी का नाम"
            name="beneficiaryName"
            rules={[{ required: true, message: "लाभार्थी का नाम भरें" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="पिता का नाम" name="fatherHusbandName">
            <Input />
          </Form.Item>

          <Form.Item label="परिवार पहचान पत्र नंबर (8 अंक)" name="familyId">
            <Input maxLength={8} />
          </Form.Item>

          <Form.Item label="मोबाइल नंबर" name="mobile">
            <Input maxLength={10} />
          </Form.Item>

          <Form.Item
            label="आय वर्ग"
            name="incomeGroup"
            rules={[{ required: true, message: "आय वर्ग चुनें" }]}
          >
            <Select>
              <Option value="रु. 1.00 लाख से कम">रु. 1.00 लाख से कम</Option>

              <Option value="रु. 1.00 लाख से रु. 1.80 लाख के बीच">
                रु. 1.00 लाख से रु. 1.80 लाख के बीच
              </Option>

              <Option value="रु. 1.80 लाख से रु. 3.00 लाख के बीच">
                रु. 1.80 लाख से रु. 3.00 लाख के बीच
              </Option>

              <Option value="रु. 3.00 लाख से रु. 5.00 लाख के बीच">
                रु. 3.00 लाख से रु. 5.00 लाख के बीच
              </Option>

              <Option value="रु. 5.00 लाख से अधिक">रु. 5.00 लाख से अधिक</Option>
            </Select>
          </Form.Item>

          <Form.Item label="ग्राम" name="village">
            <Input />
          </Form.Item>

          <Form.Item
            label="क्या ग्राम सभा इस आय वर्ग से सहमत है?"
            name="isAgreed"
          >
            <Radio.Group>
              <Radio value="हाँ">हाँ</Radio>

              <Radio value="नहीं">नहीं</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="यदि नहीं, तो कारण बताएं" name="reason">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};

export default BeneficiaryIncomeScreen;
